import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { Union } from "../../common/Union";
import { staggeredBaseQuery } from "./staggeredBaseQuery";

export const unionApi = createApi({
    reducerPath: "unionApi",
    tagTypes: ["Union"],
    baseQuery: staggeredBaseQuery(""),
    endpoints: (builder) => ({
        getAllUnions: builder.query<Union[], void>({
            query: () => {
                return{
                    method:"GET",
                    url:"unions/"
                }
            }
        }),
        getUnion: builder.query<Union, String>({
            query: (unionId) => {
                return {
                    method: "GET",
                    url: `unions/${unionId}`,
                }
            }
        }),
        addEmail: builder.mutation<Union, { id: number, email: string }>({
            query: ({ id, email }) => {
                return {
                    method: "PUT",
                    url: `unions/${id}`,
                    body: email,
                }
            },
            invalidatesTags: [{ type: "Union", id: "LIST" }],
        }),
        updateUnion: builder.mutation<Union, { unionId: string; union: Partial<Union> }>({
            query: ({ unionId, union }) => {
                return {
                    method: "PUT",
                    url: `unions/${unionId}`,
                    body: union,
                }
            },
            invalidatesTags: (result, error, { unionId }) => [
                { type: "Union", id: unionId },
              ],
        }),
        deleteUnionEmail: builder.mutation<void, { unionId: string; email: string }>({
            query: ({ unionId, email }) => {
                return {
                    method: "DELETE",
                    url: `unions/${unionId}/email`,
                    body: email,
                }
            },
            invalidatesTags: (result, error, unionId) => [
                { type: "Union", unionId },
              ],
        })
    })
})

export const {
    useGetAllUnionsQuery,
    useGetUnionQuery,
    useAddEmailMutation,
    useUpdateUnionMutation,
    useDeleteUnionEmailMutation,
} = unionApi;